
<app-header-auth></app-header-auth>
<div class="m-auto container text-center">

    <div class="card login-form border-0  m-auto">

      <div class="card-header border-0 bg-none mt-3">
        <h4 class="text-center"> {{'SIGNIN' | translate}}</h4>
      </div>
      <span class="text-danger" *ngIf="this.admin.error?.message">მომხმარებელი არ არსებობს</span>
      <div class="card-body p-0 mt-3">

        <form [formGroup]="validateForm" class="login-form" (ngSubmit)="submitForm()">

          <div class="form-floating mb-3">
            <input
              [ngClass]="{'is-invalid': this.admin.error?.message}"
              type="text"
              class="form-control"
              formControlName="user"
              id="user"
              placeholder="{{ 'EMAIL' | translate }}"
              required
              autocomplete="email">
            <label for="user">{{ 'EMAIL' | translate }}</label>
            <div class="invalid-feedback">
              {{this.admin.error?.error?.email}}
            </div>
          </div>

          <div class="form-floating mb-3">
            <input
              [ngClass]="{'is-invalid': this.admin.error?.message}"
              type="password"
              class="form-control"
              formControlName="password"
              id="password"
              placeholder="{{ 'PASSWORD' | translate }}"
              required
              autocomplete="current-password">
            <label for="password">{{ 'PASSWORD' | translate }}</label>
            <div class="invalid-feedback">
              {{this.admin.error?.error?.password}}
            </div>
          </div>

          <div class="form-floating mb-3">
            <button
              class="btn btn-lg w-100 btn-primary rounded-3"
              [disabled]="!validateForm.valid">
              <span *ngIf="admin.loading" class="spinner-border spinner-border-sm" role="status" ></span>
              {{ 'SIGNIN' | translate }}
            </button>
          </div>
          

        </form>

        <!-- <div class="form-floating mb-3">
          <button
            class="btn btn-lg border w-100 mb-1 rounded-3">
            <fa-icon [icon]="faApple"></fa-icon> Continue with Apple
          </button>

          <button
            class="btn btn-lg border w-100 mb-1 rounded-3">
            <fa-icon [icon]="faGoogle"></fa-icon> Continue with Google
          </button>

          <button
            class="btn btn-lg border w-100 mb-1 rounded-3">
            <fa-icon [icon]="faMicrosoft"></fa-icon> Continue with Microsoft Account
          </button>
        </div> -->

        

        <a routerLink="/reset/password" class="text-muted">{{ 'RESETPASS' | translate }}</a>

        <div class="d-flex align-items-center justify-content-center mt-2">
            <p class="mb-0 me-2">{{ 'NO_ACCAUNT' | translate}} ?</p>
            <a type="button" routerLink="/signup"  class="btn btn-outline-danger">{{ 'SIGNUP' | translate }}</a>
        </div>


      </div>

    </div>

</div>

